<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item label="标签名称" prop="prjTagName">
            <el-input
              v-model="formData.prjTagName"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item label="标签类型" prop="prjTagType">
            <el-select
              v-model="formData.prjTagType"
              size="small"
              placeholder="请选择标签类型"
              style="width:100%;"
              :disabled="disabled"
              clearable
              filterable
            >
              <el-option label="公共标签" value="C"></el-option>
              <el-option label="私有标签" value="P"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item label="标签所属人" prop="prjTagOwner">
            <el-input v-model="formData.prjTagOwner" disabled clearable size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item label="状态" prop="prjTagStatus">
            <el-radio-group style="width: 100%;" size="small" disabled v-model="formData.prjTagStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span>Create：{{formData.createByName?formData.createByName:'--'}} at {{formData.createDate?formData.createDate:'--'}}</span>
            <br/>
            <span>Modify：{{formData.modifyByName?formData.modifyByName:'--'}} at {{formData.modifyDate?formData.modifyDate:'--'}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  data () {
    return {
      createDataDisabled:true,
      disabled: false,
      formData: {
        prjTagCode: '',
        prjTagType: 'C',
        prjTagOwner: '',
        prjTagName: '',
        prjTagStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      },
      rules: {
        prjTagType: [
          { required: true, message: '请选择标签类型', trigger: 'blur' }
        ],
        prjTagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
          { max: 50, message: '长度在50个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad (ref, val = '') {
      this.init()
      if (ref !== 'add') {
        this.createDataDisabled = true
        let param = { prjTagCode: val }
        this.$api.prjTagDetailApi(param).then(res => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.disabled = true
        }
      }else{
        this.createDataDisabled = false
      }
    },
    // 保存数据
    save () {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.prjTagSaveApi(this.formData)
            .then(res => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success'
              })
              // 通知父组件保存成功
              this.$emit('success')
            })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init () {
      this.disabled = false
      this.formData = {
        prjTagCode: '',
        prjTagType: 'C',
        prjTagOwner: '',
        prjTagName: '',
        prjTagStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      }
    }
  }
}
</script>
